import api from '../index'
import { faker } from '@faker-js/faker'
const requests = {
    ProductSellThroughReport: {
        createMockedData: async () => {
            try {
                // int Id { get; set; }
                // string ProntoId { get; set; }
                // string Description { get; set; }
                // int TotalSold { get; set; }
                // int TotalAllocated { get; set; }
                // int TotalOnBackorder { get; set; }
                // decimal AverageSalePrice { get; set; }
                // decimal Value { get; set; } // value of what?
                // decimal TotalProfit { get; set; }

                var retObj = {
                    data: [],
                    pageIndex: 0,
                    totalCount: 10,
                    totalPages: 5
                }
                var i = 1
                while (i < 10) {
                    var obj = {
                        id: faker.datatype.number(),
                        prontoId: faker.datatype.number(),
                        description: faker.commerce.productName(),
                        totalSold: faker.datatype.number(),
                        totalAllocated: faker.datatype.number(),
                        totalOnBackorder: faker.datatype.number(),
                        averageSalePrice: faker.datatype.float(),
                        value: faker.datatype.number(),
                        totalProfit: faker.datatype.float()
                    }
                    retObj.data.push(obj)
                    i++
                }

                return retObj
            } catch (error) {
                console.error(error)
            }
        }
    },
    ProactiveRefreshReport: {
        createMockData: async () => {
            try {
                var response = {
                    lines: [],
                    pageIndex: 0,
                    totalCount: 10,
                    totalPages: 5
                }
                var i = 1
                while (i < 50) {
                    response.lines.push({
                        Id: faker.datatype.number(),
                        Code: faker.datatype.number(),
                        Description: faker.commerce.productName(),
                        Sales: {
                            January: {
                                count: faker.datatype.number(),
                                SalesPriceEx: faker.datatype.number()
                            },
                            February: {
                                count: faker.datatype.number(),
                                SalesPriceEx: faker.datatype.number()
                            },
                            March: {
                                count: faker.datatype.number(),
                                SalesPriceEx: faker.datatype.number()
                            },
                            April: {
                                count: faker.datatype.number(),
                                SalesPriceEx: faker.datatype.number()
                            }
                        },
                        xIndex: i
                    })
                    i++
                }

                return response
            } catch (err) {
                console.error(err)
            }
        },
        //Get list of Customer based on Product ID
        fetchMockDataByProductID: async (productId) => {
            try {
                var res = {
                    id: productId,
                    code: 'Z11B-14-RES',
                    description: 'No Description',
                    brand: null,
                    pageIndex: 0,
                    totalCount: 10,
                    totalPages: 5,
                    lines: []
                }
                var i = 1
                while (i < 25) {
                    res.lines.push({
                        invoiceNumber: '820370',
                        invoiceDate: '2021-08-09T00:00:00Z',
                        repCode: 'JNG',
                        customerName: 'Commonwealth Bank of Australia',
                        customerId: 'MQCOMM',
                        id: 148716,
                        code: 'Z11B-14-RES',
                        description: 'No Description',
                        brand: null,
                        quantity: 0,
                        totalSalePriceEx: 1835.4545,
                        totalProfit: 76.25450000000001,
                        margin: 0
                    })
                    i++
                }

                return res
            } catch (err) {
                console.error(err)
            }
        },
        fetchMockDataCustomerInfo: async (productId, customerId) => {
            try {
                var res = {
                    id: productId,
                    code: 'Z11B-14-RES',
                    description: 'No Description',
                    brand: null,
                    pageIndex: 0,
                    totalCount: 10,
                    totalPages: 5,
                    lines: []
                }
                var i = 1
                while (i < 25) {
                    res.lines.push({
                        invoiceNumber: '820370',
                        invoiceDate: '2021-08-09T00:00:00Z',
                        repCode: 'JNG',
                        customerName: 'Commonwealth Bank of Australia',
                        customerId: customerId,
                        id: 148716,
                        code: 'Z11B-14-RES',
                        description: 'No Description',
                        brand: null,
                        quantity: 0,
                        totalSalePriceEx: 1835.4545,
                        totalProfit: 76.25450000000001,
                        margin: 0
                    })
                    i++
                }

                return res
            } catch (err) {
                console.error(err)
            }
        }
    }
}

export default requests
